// eslint-disable-next-line
import React, { useContext, lazy, Suspense } from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import Routes from './Routes'
import './fonts.css'
import { GlobalMusicProvider } from './context/GlobalMusicContext'
import { MusicPlayerProvider } from './context/MusicPlayerContext'
import Navbar from './components/Header/Navbar'
import { Player } from './components/Player/Player'
import { customTheme } from './utils/custom-theme'
import { TracksList } from './components/SearchResults/TracksList'
// import { QueryCache, ReactQueryCacheProvider } from 'react-query'
// import { ReactQueryDevtools } from 'react-query-devtools'
// import { useAuth } from './hooks/useAuth'
// import UserContext from './context/AuthContext'

function App( props ) {
  // const queryCache = new QueryCache()
  // const [user, setUser] = useAuth()
  // <UserContext.Provider value={{ user, setUser }}>
  // </UserContext.Provider>

  return (
    <GlobalMusicProvider>
      <MusicPlayerProvider>
        {props.children}
        <Router>
          <Navbar />
          <main>
            <Routes />
            <TracksList />
          </main>
          <Player theme={customTheme} />
        </Router>
        {/* <ReactQueryDevtools  initialIsOpen={false} position="bottom-right" /> */}
      </MusicPlayerProvider>
    </GlobalMusicProvider>
  )
}
export default App
